import * as Yup from "yup";

const validarTiposPessoa = (tiposPessoa, id) => 
  Array.isArray(tiposPessoa) && tiposPessoa.includes(id);

const pessoasCsvValidator = Yup.array()
  .of(
    Yup.object().shape({
      naturezaSocial: Yup.string().required("Natureza Social"),
      nomeRazaoSocial: Yup.string().required("Nome"),
      apelidoFantasia: Yup.string().nullable(),
      dataAbertura: Yup.date().when("naturezaSocial", {
        is: "juridica",
        then: Yup.date("Data de abertura").max(new Date()).nullable(),
        otherwise: Yup.date("Data de abertura").nullable(),
      }),
      dataNascimento: Yup.date().when("naturezaSocial", {
        is: "fisica",
        then: Yup.date("Data de nascimento").max(new Date()).nullable(),
        otherwise: Yup.date("Data de nascimento").nullable(),
      }),
      cnpjCpf: Yup.string().when("naturezaSocial", {
        is: "fisica",
        then: Yup.string("CPF").nullable(),
        otherwise: Yup.string("CNPJ").nullable(),
      }),
      inscricaoEstadual: Yup.string().nullable(),
      inscricaoEstadualRural: Yup.string().nullable(),
      rg: Yup.string().nullable(),
      contato: Yup.string().nullable(),
      email: Yup.string().nullable(),
      telefone: Yup.number("Telefone")
        .nullable()
        .test(
          "tamStringTelefone",
          "Telefone Válido",
          (value) => !value || value?.toString().length == 10
        ),
      celular: Yup.number("Celular")
        .nullable()
        .test(
          "tamStringCelular",
          "Celular Válido",
          (value) => !value || value?.toString().length == 11
        ),
      sexo: Yup.string().nullable(),
      idTiposPessoa: Yup.array().nullable(),
      endereco: Yup.object().shape({
        cep: Yup.string()
            .matches(/^[0-9]{8}$/, "CEP inválido")
            .required("CEP"),
        logradouro: Yup.string().required("Logradouro"),
        numero: Yup.string().required("Número"),
        bairro: Yup.string().required("Bairro"),
        cidadeId: Yup.number().required("Cidade"),
        descricao: Yup.string().nullable(),
        complemento: Yup.string().nullable(),
      }).nullable(),
      cliente: Yup.object().when("idTiposPessoa", {
        is: (idTiposPessoa) => validarTiposPessoa(idTiposPessoa, 1),
        then: Yup.object().shape({
          grupoPessoaId: Yup.number().nullable(),
          tipoContribuinteId: Yup.number().required("Tipo de Contribuinte"),
          indicadorConsumidorFinal: Yup.boolean().required("Consumidor Final"),
          mensagemVenda: Yup.string().nullable(),
          limiteCompra: Yup.number().nullable(),
        }),
        otherwise: Yup.object().nullable(),
      }),
      fornecedor: Yup.object().when("idTiposPessoa", {
        is: (idTiposPessoa) => validarTiposPessoa(idTiposPessoa, 2),
        then: Yup.object().shape({
          limiteCompra: Yup.number().required("Limite de Compra"),
          grupoPessoaId: Yup.number().nullable(),
        }),
        otherwise: Yup.object().nullable(),
      }),
      transportadora: Yup.object().when("idTiposPessoa", {
        is: (idTiposPessoa) => validarTiposPessoa(idTiposPessoa, 3),
        then: Yup.object().shape({
          localEmbarque: Yup.string().required("Local de Embarque"),
          localDesembarque: Yup.string().nullable(),
          rntc: Yup.string().nullable(),
          grupoPessoaId: Yup.number().nullable(),
        }),
        otherwise: Yup.object().nullable(),
      }),
      colaborador: Yup.object().when("idTiposPessoa", {
        is: (idTiposPessoa) => validarTiposPessoa(idTiposPessoa, 4),
        then: Yup.object().shape({
          grupoPessoaId: Yup.number().nullable(),
          funcao: Yup.string().required("Função"),
          dataAdmissao: Yup.date().nullable(),
          dataDemissao: Yup.date().nullable(),
          vendedor: Yup.boolean().required("Vendedor"),
          motorista: Yup.boolean().required("Motorista"),
          comissaoPrazo: Yup.number().when("vendedor", {
            is: true,
            then: Yup.number().nullable(),
            otherwise: Yup.number("Comissão a Prazo")
              .nullable()
              .test(
                "isNull",
                "Deve ser null/undefined",
                (value) => value === null || value === undefined
              ),
          }),
          comissaoVista: Yup.number().when("vendedor", {
            is: true,
            then: Yup.number().nullable(),
            otherwise: Yup.number("Comissão a Vista")
              .nullable()
              .test(
                "isNull",
                "Deve ser null/undefined",
                (value) => value === null || value === undefined
              ),
          }),
          descontoMaximo: Yup.number().when("vendedor", {
            is: true,
            then: Yup.number().nullable(),
            otherwise: Yup.number("Desconto Máximo")
              .nullable()
              .test(
                "isNull",
                "Deve ser null/undefined",
                (value) => value === null || value === undefined
              ),
          }),
        }),
        otherwise: Yup.object().nullable(),
      }),
      prestadorServico: Yup.object().when("idTiposPessoa", {
        is: (idTiposPessoa) => validarTiposPessoa(idTiposPessoa, 5),
        then: Yup.object().shape({
          profissao: Yup.string().required("Profissão"),
          grupoPessoaId: Yup.number().nullable(),
          comissaoPrazo: Yup.number().nullable(),
          comissaoVista: Yup.number().nullable(),
        }),
        otherwise: Yup.object().nullable(),
      }),
      profissional: Yup.object().when("idTiposPessoa", {
        is: (idTiposPessoa) => validarTiposPessoa(idTiposPessoa, 6),
        then: Yup.object().shape({
          profissao: Yup.string().required("Profissão"),
          grupoPessoaId: Yup.number().nullable(),
          comissao: Yup.number().nullable(),
        }),
        otherwise: Yup.object().nullable(),
      }),
    })
  )
  .min(1, "Adicione ao menos um item")
  .required("Adicione ao menos um item");

export default pessoasCsvValidator;
